import { getFrontendRuntimeContext } from './frontendRuntimeContext';

// simple logging abstraction that we can override on server to get SSR logs
// into the standard logging path on server, rather than emitting to console.log
// eslint-disable-next-line no-console
let defaultLog = console.log.bind(null, '[INFO]');
let defaultError = console.error.bind(null, '[ERR]');

const frontendLog = {
  log: (...args: any[]) => (getFrontendRuntimeContext()?.log || defaultLog)(...args),
  error: (...args: any[]) => (getFrontendRuntimeContext()?.error || defaultError)(...args),
  setLogProviders: (logFn: any, errorFn: any) => {
    const context = getFrontendRuntimeContext();
    if (context) {
      context.log = logFn;
      context.error = errorFn;
      return;
    }
    defaultLog = logFn;
    defaultError = errorFn;
  }
};

export default frontendLog;
